import React from 'react';

class RenderWsRow extends React.Component {
  constructor(props) {
    super(props);
    this.addWsMeeting = this.addWsMeeting.bind(this);
  }

  addWsMeeting(id, name) {
    this.props.addWsPopup.callback(id, name);
    this.props.closeWsModelBox();
  }

  render() {
    const { wsData } = this.props;
    return (
      <div>
        <div id="meetingWsListData" className="teamBorder">
          <div className="teamTitle padTop15">
            {wsData.name}
          </div>
          <div>
            {
            (typeof wsData.ws === 'object' && wsData.ws != null && Object.keys(wsData.ws).length)
              ? Object.entries(wsData.ws).map(ws => (
                <div className="padLeft15">
                  {
                    ws.map((item, index) => (
                      <div className="workStreamList" key={index} onClick={() => this.addWsMeeting(item.id, item.name)}>{item.name}</div>
                    ))
                }
                </div>
              ))
              : ''
            }
          </div>
        </div>
      </div>
    );
  }
}
export default RenderWsRow;
